module.exports = __webpack_public_path__ + "media/assets/images/flags/rw-f5e18e0dcd6ad3b9225e12fd8e380737.svg";